(function(w, $, _) {
    const assetId = 'search-results-default-script';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {
        
        $(w).load(function() {

            const addedText = ctx.labels.addedToWishList;
            const removedText = ctx.labels.removedFromWishList;
            const anonymous = ctx.isAnonymousUser;

            const mainPanelSelector = '#' + ctx.mainPanelID;

            const mainPanelContainer = $(mainPanelSelector);
            const $itemContainers = mainPanelContainer.find('.SearchItemContainer[data-itemid]');
            const addLinks = $('a.WishListAdd', mainPanelSelector).hide();
            const removeLinks = $('a.WishListRemove', mainPanelSelector).hide();

            const $listTitle = mainPanelContainer.find('.MainTitle');

            reportImpressions($listTitle, $itemContainers);

            //New flag system
            if (ctx.useNewFlagSystem) {
                // Get flags
                const itemIds = [];
                for (let i = 0; i < $itemContainers.length; i++) {
                    if ($($itemContainers[i]).data('productid')) {
                        itemIds.push($($itemContainers[i]).data('itemid'));
                    }
                }

                $.get(w.R + 'startup/api/v1/acrhive/flags/connections/visible',
                    {
                        itemIds: itemIds,
                        archiveType: 20,
                    }).done(function(data) {
                    _.each(data,
                        function(flags, itemId) {
                            const $prodContainer = $itemContainers.filter('[data-itemid="' + itemId + '"]');
                            let $prodImage = $prodContainer.find('.js-flags-target-uc170');
                            if ($prodImage.length === 0) {
                                // Fallback to the old implementation. May be useful for custom views
                                $prodImage = $prodContainer.find('img.Image');
                            }
                            _.each(flags,
                                function(flagDetails) {
                                    const $em = $('<em />',
                                        {
                                            'class': 'Flag flag flag_uc170 flag-' +
                                                flagDetails.FlagID +
                                                ' ' +
                                                flagDetails.Name,
                                            text: flagDetails.Name
                                        });
                                    $em.data('flag', flagDetails);
                                    $em.insertBefore($prodImage);
                                });

                            w.PubSub.publish('product.flags.created', [itemId, $prodContainer, flags]);
                        });
                }).error(function() {
                    console.error('Failed to load flags');
                });
            }

            //Get wishlist items
            if (w.PublicEStore && anonymous === false && addLinks.length > 0) {
                $.when(w.PublicEStore.getWishList().then(function(c) {
                    if (!c || !c.result) {
                        return;
                    }

                    addLinks.click(function(e) {
                        e.preventDefault();
                        const t = $(this);
                        const productId = parseInt(t.closest('div.SearchItemContainer').data('productid'));
                        const prodName = t.closest('div.SearchItemContainer').find('a.ItemTitleLink').text();

                        $.when(w.PublicEStore.addToWishList(productId).then(function() {
                                //Hide add
                                t.hide();

                                //Show remove
                                t.siblings('a.WishListRemove').show();

                                //Show message
                                msg(prodName + ' ' + addedText, 'success');
                            },
                            function(errContract) {
                                if (!errContract) {
                                    return;
                                }

                                let errMsg = errContract.message;

                                if (errContract.result &&
                                    errContract.result.items &&
                                    errContract.result.items.length > 0) {
                                    errMsg = errContract.result.items[0].message;
                                }

                                msg(errMsg, 'error');
                            }));
                    });

                    removeLinks.click(function(e) {
                        e.preventDefault();
                        const t = $(this);
                        const productId = parseInt(t.closest('div.SearchItemContainer').data('productid'));
                        const prodName = t.closest('div.SearchItemContainer').find('a.ItemTitleLink').text();

                        $.when(w.PublicEStore.removeFromWishList(productId).then(function() {

                                //Hide remove
                                t.hide();

                                //Show add
                                t.siblings('a.WishListAdd').show();

                                //Show message
                                msg(prodName + ' ' + removedText, 'warning');

                            },
                            function(errContract) {
                                if (!errContract) {
                                    return;
                                }

                                let errMsg = errContract.message;

                                if (errContract.result &&
                                    errContract.result.items &&
                                    errContract.result.items.length > 0) {
                                    errMsg = errContract.result.items[0].message;
                                }

                                msg(errMsg, 'error');
                            }));
                    });

                    const productIds = c.result.items && c.result.items.length > 0
                        ? _.pluck(c.result.items, 'productId')
                        : [];

                    const rows = $('div.SearchItemContainer:not([data-productid=""])', mainPanelSelector);

                    const inWishList = rows.filter(function() {
                        return _.contains(productIds, $(this).data('productid'));
                    });

                    const notInWishList = rows.filter(function() {
                        return !_.contains(productIds, $(this).data('productid'));
                    });

                    $('a.WishListAdd', inWishList).hide();
                    $('a.WishListAdd', notInWishList).show();
                    $('a.WishListRemove', inWishList).show();
                    $('a.WishListRemove', notInWishList).hide();
                }));
            }

            // Setup added to card container handling
            _.each(ctx.quantitiesInCart,
                function(qty, prodId) {
                    const $prodCont = mainPanelContainer.find('.SearchItemContainer[data-productId="' + prodId + '"]');
                    if ($prodCont.length === 1) {
                        $prodCont.find('.ProdCount').text(qty);
                        $prodCont.find('.AddToCartContainer').show();
                    }
                });

            // Setup add to card container handling
            $.publicFetch({
                handler: 'EStoreData',
                data: {
                    a: 'GetTempOrderLineProductIDs'
                },
                success: function(data) {
                    ctx.tolProducts = data;
                    _.each(data,
                        function(tolProductId, idx) {
                            $('.SearchItemContainer[data-productId="' + tolProductId + '"] .AddToCartContainer',
                                mainPanelSelector).show().closest('.MakeOrderContainer').show();
                        });
                },
                error: function(error) {
                    console.error('An error has occured fetching temp order line products: ', error);
                }
            });

            // Setup MessagesCont
            $('.MessagesCont', mainPanelSelector).each(function(idx, elem) {
                const $elem = $(elem);
                if ($.trim($elem.html()).length === 0) {
                    $elem.removeClass('Active');
                } else {
                    $elem.addClass('Active');
                    // Set timeout to hide
                    let autoHideErrMsgTimout = setTimeout(function() {
                            $('.MessagesCont.Active', mainPanelSelector).fadeOut('slow');
                        },
                        5000);

                    $elem.click(function() {
                        if (autoHideErrMsgTimout) {
                            clearTimeout(autoHideErrMsgTimout);
                            autoHideErrMsgTimout = null;
                        }

                        $(this).closest('.MessagesCont').hide();
                        return false;
                    });

                    $elem.append($('<div />',
                            {
                                'class': 'CloseMessage'
                            })).wrapInner('<div class="MessageContActiveArea" />')
                        .wrapInner('<div class="InnerMessageCont" />');
                }
            });

            // Hide make order containers if there is only AddToCartContainer inside
            $('.MakeOrderContainer', mainPanelSelector).each(function() {
                const childCount = $(this).children().length;
                if (childCount === 0 || childCount === 1 && $(this).find('.AddToCartContainer').length === 1) {
                    $(this).hide();
                }
            });

            // Setup MPEF
            if (w.globalSettings.enableMPEF) {
                mainPanelContainer.find('.BuyBtn').click(function(evt) {

                    const mainProdContainer = $(this).closest('div[data-productid]');

                    if (mainProdContainer.length === 1) {
                        evt.preventDefault();
                        tryBuy(mainProdContainer);
                    }
                });

                // Subscribe to removeFromCart event and hide shopCart icon
                const removeFromCartTopic = w.PublicEStore.channels.callback.shopCart +
                    '.' +
                    w.PublicEStore.actions.removeFromCart;
                const emptyCartTopic = w.PublicEStore.channels.callback.shopCart + '.' + w.PublicEStore.actions.emptyCart;
                const addToCartTopic = w.PublicEStore.channels.callback.shopCart + '.' + w.PublicEStore.actions.addToCart;
                w.PublicEStore.subscribe(removeFromCartTopic, removeFromCartHandler);
                w.PublicEStore.subscribe(emptyCartTopic, emptyCartHandler);
                w.PublicEStore.subscribe(addToCartTopic, addToCartGlobalCallback);
            }

        });

        const notys = [];

        function msg(text, type) {
            if (!w.PubSub || !text || text.length === 0) {
                return;
            }

            type = type || 'info';

            if (notys && notys.length > 3) {
                const noty = notys.shift();
                if (noty) {
                    noty.close();
                }
            }

            w.PubSub.publish('notification',
                { type: type, timeout: 10 * 1000, text: text, notyCallback: function(n) { notys.push(n); } });
        };

        function tryBuy($prodContainer) {
            const productId = $prodContainer.attr('data-productId');

            if (productId === 0) {
                showError($prodContainer, ctx.labels.selectAvailableDimensionsMsg);
                return;
            }

            let redirectUrl = $prodContainer.attr('data-redirectUrl');

            if (redirectUrl) {
                const quantity = $prodContainer.find('.QuantityContainer input.QuantityTxb').val();
                if (quantity) {
                    redirectUrl = '{0}&qt={1}'.format(redirectUrl, quantity);
                }
                w.location.href = redirectUrl;
                return;
            }

            const contract = composeAddToCartDataContract($prodContainer);

            if (contract && !isNaN(contract.quantity.toString().replace(/[,.]/g, ''))) {
                $prodContainer.addClass('buying');
                $.when(w.PublicEStore.addToCart(contract)).then(addToCartCallback, errorCallback).always(function() {
                    $('#' + ctx.mainPanelID).find('.SearchItemContainer').removeClass('buying');
                });
            }
        };

        function showError(mainProdContainer, errorMsg) {
            const $mainProdCont = $(mainProdContainer);

            // Try to find product name or product number to use it as an error prefix
            var prodName = $mainProdCont.find('.ItemTitleLink').text();
            if (!prodName) {
                prodName = $mainProdCont.find('.ProductNumber').text();
            }

            const errorPrefix = prodName ? '<b>' + prodName + '</b>: ' : '';

            // Show error
            w.PubSub.publish('notification.error', errorPrefix + errorMsg);
        };

        function composeAddToCartDataContract(mainProdContainer) {
            const customFields = {};
            mainProdContainer.find('.customFieldsCont .customField').each(function(idx, elem) {
                let $elem = $(elem);
                const customFieldId = $elem.attr('customFieldId');

                //Special handling for checkbox because they are wrapped in a span
                if ($elem.find('input').length > 0) {
                    $elem = $elem.find('input');
                }

                if (customFieldId) {
                    const cfValue = $elem.is(':checkbox') ? $elem.is(':checked').toString() : $elem.val();
                    customFields[customFieldId] = cfValue;
                }
            });

            return {
                productId: mainProdContainer.attr('data-productId'),
                quantity: mainProdContainer.find('.QuantityContainer input.QuantityTxb').val(),
                fraction: mainProdContainer.find('.FractionRow input.Fraction').val(),
                customFields: customFields,
                imageId: mainProdContainer.find('input:hidden[id*="hProductImageId"]').val()
            };
        };

        function addToCartCallback(dataContract) {
            const mainPanelContainer = $('#' + ctx.mainPanelID);

            _.each(dataContract.result.items,
                function(prod) {
                    if (typeof prod === 'object' && prod) {
                        const prodContainer = mainPanelContainer.find('.SearchItemContainer[data-productId="' + prod.productID + '"]');
                        if (prod.status.toLowerCase() !== 'ok') {
                            showError(prodContainer, prod.message);
                        }
                    }
                });
        };

        function addToCartGlobalCallback(channel, contract) {
            const mainPanelContainer = $('#' + ctx.mainPanelID);

            _.each(contract.result.items,
                function(prod) {
                    if (typeof prod === 'object' && prod) {
                        const prodContainer = mainPanelContainer.find('.SearchItemContainer[data-productId="' + prod.productID + '"]');
                        if (prod.status.toLowerCase() === 'ok') {
                            // Update total product's count for the current temp order line
                            const orderLineQuantityContainer = prodContainer.find('.ProdCount');
                            orderLineQuantityContainer.text(prod.totalQuantityInTempOrderLine);

                            // Animate action
                            const addToCartIconContainer = prodContainer.find('.AddToCartContainer');
                            addToCartIconContainer.show();
                            prodContainer.effect('transfer',
                                { to: addToCartIconContainer },
                                500,
                                function() {
                                    addToCartIconContainer.effect('bounce', null, 500);
                                });

                            ctx.quantitiesInCart[parseInt(prod.productID)] = prod.totalQuantityInTempOrderLine;
                        }
                    } else {
                        console.error('An error has occured while processing AddToCart callback contract');
                    }
                });
        }

        function errorCallback(dataContract) {
            var mainPanelContainer = $('#' + ctx.mainPanelID);

            if (dataContract.message) {
                msg(dataContract.message, 'error');
            }

            if (dataContract.result && dataContract.result.items) {
                _.each(dataContract.result.items,
                    function(prod) {
                        if (typeof prod === 'object' && prod) {
                            const prodContainer = mainPanelContainer.find('.SearchItemContainer[data-productId="' +
                                prod.productID +
                                '"]');
                            showError(prodContainer, prod.message);
                        } else {
                            console.error('An error has occured while processing error callback contract');
                        }
                    });
            }
        };

        function removeFromCartHandler(topic, dataContract) {
            var mainPanelContainer = $('#' + ctx.mainPanelID);
            _.each(dataContract.result.items,
                function(prod) {
                    if (typeof prod === 'object' && prod && prod.status.toLowerCase() === 'ok') {
                        mainPanelContainer.find('.SearchItemContainer[data-productId="' +
                            prod.productID +
                            '"] .AddToCartContainer').hide();
                        delete ctx.quantitiesInCart[parseInt(prod.productID)];
                    }
                });
        };

        function emptyCartHandler(topic, dataContract) {
            if (dataContract.status.toLowerCase() === 'ok') {
                const mainPanelContainer = $('#' + ctx.mainPanelID);
                mainPanelContainer.find('.SearchItemContainer .AddToCartContainer').hide();
                ctx.quantitiesInCart = {};
            }
        };

        function reportImpressions($listTitle, $productContainers) {
            try {
                const listName = $.trim($listTitle.text() || document.title);
                const productImpressions = [];

                $productContainers.each(function() {
                    const $prod = $(this);

                    const productId = parseInt($prod.data('productid'));
                    if (productId > 0) {
                        productImpressions.push({ productId: productId, $links: $prod.find('.js-product-link') });
                    }
                });

                if (productImpressions.length > 0) {
                    w.reportProductListView(w.productListType.searchResults, listName, productImpressions);
                }
            } catch (e) {
                console.error('Failed to report products impressions. ' + e);
            }
        }
    }
})(window, jQuery, _);